export default "__VITE_ASSET__ZDRexWHb__"